import { Icon } from '@buggy/shared'
import { Switch, SwitchProps } from 'antd'
import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

type AISwitchProps = SwitchProps

const AISwitch: FunctionComponent<AISwitchProps> = (props) => {
  return <StyledSwitch {...props} />
}

interface ChildWithAIBadgeProps {
  children: ReactNode
}

export const ChildWithAIBadge: FunctionComponent<ChildWithAIBadgeProps> = ({
  children,
}) => {
  return (
    <Wrapper>
      <Icon name='ai-badge-outlined' />
      <Text>{children}</Text>
    </Wrapper>
  )
}

const StyledSwitch = styled(Switch)`
  &.ant-switch-checked,
  &.ant-switch.ant-switch-checked:hover:not(.ant-switch-disabled) {
    background: linear-gradient(90deg, #cadaff 0%, #dbc5ff 100%);
  }
`

const Text = styled.div`
  margin: 0 4px;
`

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }): string => theme.colors.gray10};
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
`

export default AISwitch
